import React from 'react';

import { useModal } from './use-modal';
import { OEModal } from '../../atoms/oe-modal/oe-modal';

export const OEModalWithinContext: React.FC = () => {
  const { modalContent, closeModal } = useModal();

  if (!modalContent) return null;
  return (
    <OEModal onClose={closeModal} visible showCloseButton>
      {modalContent}
    </OEModal>
  );
};
